import * as React from 'react';
import { useState } from 'react';
import Dialog from '@mui/material/Dialog';
import { Chip, DialogContent, DialogTitle, Grid, IconButton, Link, Pagination, Typography } from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';
import { VideoFeature } from '../model/VideoFeature';
import './VideoDetails.css';
import { tagGroups } from '../data/TagGroups';

const evaluateTags = (isAdmin: boolean, tags: string[]) => {
  if (isAdmin) return tags;
  const selectedTagGroups = [];
  for (const tagGroup of tagGroups) if (tagGroup.tags.some(tag => tags.includes(tag))) selectedTagGroups.push(tagGroup.group);
  return selectedTagGroups;
};

export default function VideoDetails(props: {
  videoFeatures: VideoFeature[]
  open: boolean;
  onClose: () => void;
  isAdmin: boolean;
}) {
  if (!props.videoFeatures.length) return <div></div>;
  const [page, setPage] = useState(1);
  const videoFeature = props.videoFeatures[page - 1];
  return (
    <Dialog onClose={props.onClose} open={props.open} className="dialog" fullWidth={true} sx={{
      '& .MuiDialog-container': {
        '& .MuiPaper-root': {
          borderRadius: '10px',
          width: '100%',
          maxWidth: '800px',
        },
      },
    }}>
      <DialogTitle sx={{ m: 0, p: 2 }} className="dialog-title">
        <IconButton
          aria-label="close"
          onClick={props.onClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: theme => theme.palette.grey[500],
          }}
        >
          <CloseIcon/>
        </IconButton>
      </DialogTitle>
      <DialogContent className="dialog-content">
        <Grid container spacing={1}>
          <Grid item xs={12} md={6}>
            <div className="video">
              <video src={`https://cdn.dev.beautifuldestinations.app/${videoFeature.mp4Url}`}
                autoPlay={true}
                controls={true} loop={true}/>
            </div>
            <div>
              <Pagination count={props.videoFeatures.length} page={page}
                onChange={(e, p) => setPage(p)}
                className="pagination"
                size="medium"/>
            </div>
          </Grid>
          <Grid item xs={12} md={6}>
            <div className="details">
              <Typography className='label'>Creator</Typography>
              <Link href={`https://instagram.com/${videoFeature.creator}`}
                target="_blank">{videoFeature.creator}</Link>
              <br/>
              <Typography className='label'>URL</Typography>
              <Link href={`https://instagram.com/p/${videoFeature.shortCode}`}
                target="_blank">{videoFeature.shortCode}</Link>
              <br/>
              <Typography className='label'>Status</Typography>
              {videoFeature.status}
              <br/>
              <Typography className='label'>Location</Typography>
              {videoFeature.city}, {videoFeature.country}
              <br/>
              <div className='tags'>
                {evaluateTags(props.isAdmin, videoFeature.tags).map(tag => <Chip label={tag}
                  className="chip"
                  key={tag}/>)}
              </div>
            </div>
          </Grid>
        </Grid>
      </DialogContent>
    </Dialog>
  );
}
